import script from "./Old photos.vue?vue&type=script&setup=true&lang=js"
export * from "./Old photos.vue?vue&type=script&setup=true&lang=js"

import "./Old photos.vue?vue&type=style&index=0&id=3acfe93e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.4_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acfe93e"]])

export default __exports__